<footer *ngIf="pageContent" class="{{pageContent.mainClass}}">
  <div class="container-box desktopAlinment">
    <div *ngIf="pageContent.product == 'fnabc'" class="row flex-column fn-footer-line sm-hide">
      <h4 class="col-sm-12 col-md-8">FirstNet links</h4>
      <h4 class="col-sm-12 col-md-6 fn-social">Follow us</h4>
    </div>
    <div *ngIf="!condensedFlag">
      <h2 *ngIf="pageContent.product == 'fnabc'" class="col-sm-12 lg-hide text-center ">FirstNet links</h2>

      <div class="row flex-column">
        <!-- <div  > -->
        <div *ngIf="pageContent.product != 'fnabc'; else fnLinksElseBlock"
          class="col-sm-12 col-md-3 right-border first-col">
          <div class="footer-nav">
            <ul>
              <li *ngFor="let content of pageContent.footerNav.firstCol" class="{{content.listClass}}"><a
                  (click)="commonFunction(content.function,content.parameter)" href="{{content.href}}"
                  target="{{content.newWindow}}"><i class="{{content.imageClass}}"
                    alt=""></i><span>{{content.content}}</span><span *ngIf="content.newWindow" class="sr-only">Opens in
                    a new window.</span></a></li>
            </ul>
          </div>
        </div>
        <div *ngIf="pageContent.product != 'fnabc'" class="col-sm-12 col-md-4 right-border second-col">
          <div class="footer-nav">
            <ul>
              <li *ngFor="let content of pageContent.footerNav.secondCol" class="{{content.listClass}}"><a
                  (click)="commonFunction(content.function,content.parameter)" href="{{content.href}}"
                  target="{{content.newWindow}}"><i class="{{content.imageClass}}"
                    alt=""></i><span>{{content.content}}</span><span *ngIf="content.newWindow" class="sr-only">Opens in
                    a new window.</span></a></li>
            </ul>
          </div>
        </div>
        <!-- </div> -->

        <ng-template #fnLinksElseBlock>
          <div class="col-sm-12 col-md-3 first-col">
            <div class="footer-nav">
              <ul>
                <li *ngFor="let content of pageContent.footerNav.firstCol" class="{{content.listClass}}"><a
                    (click)="commonFunction(content.function,content.parameter)" href="{{content.href}}"
                    target="{{content.newWindow}}"><span>{{content.content}}</span><span *ngIf="content.newWindow"
                      class="sr-only">Opens in a new window.</span></a></li>
              </ul>
            </div>
          </div>
          <div class="col-sm-12 col-md-5 right-border second-col">
            <div class="footer-nav">
              <ul>
                <li *ngFor="let content of pageContent.footerNav.secondCol" class="{{content.listClass}}"><a
                    (click)="commonFunction(content.function,content.parameter)" href="{{content.href}}"
                    target="{{content.newWindow}}"><span>{{content.content}}</span><span *ngIf="content.newWindow"
                      class="sr-only">Opens in a new window.</span></a></li>
              </ul>
            </div>
          </div>
        </ng-template>

        <div *ngIf="pageContent.product!='fnabc'; else followusElseBlock" class="col-sm-12 col-md-4">
          <div class="social-nav">
            <ul>
              <li><a href="https://twitter.com/att" target="_blank"><span class="sr-only">Twitter (Opens in new
                    window)</span><i class="icon-social-twitterL" aria-label="Twitter." aria-hidden="true"></i></a></li>
              <li><a href="https://www.facebook.com/att" target="_blank"><span class="sr-only">Facebook (Opens in new
                    window)</span><i class="icon-social-facebookL" aria-label="Facebook." aria-hidden="true"></i></a>
              </li>
              <li><a href="http://instagram.com/att/" target="_blank"><span class="sr-only">Instagram (Opens in new
                    window)</span><i class="icon-social-instagramL" aria-label="Instagram." aria-hidden="true"></i></a>
              </li>
              <li><a href="https://www.linkedin.com/company/att" target="_blank"><span class="sr-only">Linkedin (Opens
                    in new window)</span><i class="icon-social-linkedinL" aria-label="LinkedIn."
                    aria-hidden="true"></i></a></li>
            </ul>
            <!-- <div class="forum-link"><a href="https://forums.att.com/" target="_blank"><i class="icon-bubble-forums"
                  aria-hidden="true"></i> Community forums<span class="sr-only">Opens in new window</span></a></div> -->
          </div>
        </div>
        <!-- <div *ngIf="pageContent.product=='fnabc'" > -->
        <ng-template #followusElseBlock>
          <h2 *ngIf="pageContent.product == 'fnabc'" class="col-sm-12 lg-hide text-center ">Follow us</h2>
          <div class="social-nav">
            <ul class="col-sm-12 col-md-5 first-col ">
              <li><a href="https://www.facebook.com/firstnet" target="_blank"><span class="sr-only">Facebook (Opens in
                    new window)</span><i class="icon-social-facebookL" aria-label="Facebook."
                    aria-hidden="true"></i>Facebook
                </a></li>
              <li><a href="https://www.linkedin.com/showcase/firstnet" target="_blank"><span class="sr-only">Linkedin
                    (Opens in new window)</span><i class="icon-social-linkedinL" aria-label="LinkedIn."
                    aria-hidden="true"></i>LinkedIn
                </a></li>
            </ul>
            <ul class="col-sm-12 col-md-5 second-col">
              <li><a href="https://www.twitter.com/firstnet" target="_blank"><span class="sr-only">Twitter (Opens in new
                    window)</span><i class="icon-social-twitterL" aria-label="Twitter." aria-hidden="true"></i>Twitter
                </a></li>
              <li><a href="https://www.youtube.com/firstnet" target="_blank"><span class="sr-only">Youtube (Opens in new
                    window)</span><i class="icon-social-youtubeL" aria-label="Youtube.">
                    <i aria-hidden="true" class="icon-social-youtubeL-path1"></i>
                    <i aria-hidden="true" class="icon-social-youtubeL-path2" data-focus-method="MOUSE"></i>
                  </i>Youtube
                </a></li>
            </ul>
          </div>
        </ng-template>
      </div>
      <div class="fmenu">
        <ul>
          <li *ngFor="let content of pageContent.fmenu.notCondensed" class="{{content.listClass}}"><a
              (click)="commonFunction(content.function,content.parameter)" href="{{content.href}}"
              target="{{content.newWindow}}"><span>{{content.content}}</span>
              <span *ngIf="content.newWindow" class="sr-only">Opens in a new window.</span><i
                class="{{content.imageClass}}" alt=""></i></a></li>
        </ul>
      </div>
      <div class="allright-text"><a href="https://www.att.com/gen/privacy-policy?pid=2587" target="_blank"
          class="copy-right">&copy; Copyright {{currentYear}} AT&amp;T Intellectual Property.</a>All rights reserved.
        <p *ngIf="pageContent.product=='fnabc'">FirstNet, First Responder Network Authority, and FirstNet logo are
          registered trademarks and service marks of FirstNet, an independent authority within the U.S. Department of
          Commerce. All other marks are the property of their respective owners.</p>
      </div>
    </div>
    <div *ngIf="condensedFlag">
      <div class="fmenu">
        <ul>
          <li class="{{content.listClass}}"><a (click)="commonFunction(content.function,content.parameter)"
              href="{{content.href}}" target="{{content.newWindow}}"><span>{{content.content}}</span>
              <span *ngIf="content.newWindow" class="sr-only">Opens in a new window.</span><i
                class="{{content.imageClass}}" alt=""></i></a></li>
        </ul>
      </div>
      <div class="allright-text"><a href="https://www.att.com/gen/privacy-policy?pid=2587" target="_blank"
          class="copy-right">&copy; Copyright {{currentYear}} AT&amp;T Intellectual Property.</a>All rights reserved.
        <p *ngIf="pageContent.product=='fnabc'">FirstNet, First Responder Network Authority, and FirstNet logo are
          registered trademarks and service marks of FirstNet, an independent authority within the U.S. Department of
          Commerce. All other marks are the property of their respective owners.</p>
      </div>
    </div>
  </div>
</footer>